import classNames from 'classnames';
import moment from 'moment';
import numeral from 'numeral';
import React from 'react';
import {connect} from 'react-redux';
import {getMPMUsersConnections} from '../../../../../../actions/entities/statistics/mpmUsers';
import earthFlag from '../../../../../../assets/img/other/flag-earth.svg';
import Loader from '../../../../../../components/Loader';

class MPMNumbersOfPlayersWidget extends React.Component {
  constructor(props) {
    super(props);
    this.state = {lang: 'ALL'};
  }

  fetchStats() {
    const {dispatch} = this.props;
    const onSuccess = response =>
      this.setState({data: response, loading: false});
    dispatch(
      getMPMUsersConnections(onSuccess, null, () =>
        this.setState({loading: true}),
      ),
    );
  }

  toggleLang(value) {
    const {lang} = this.state;

    if (lang === value) {
      this.setState({lang: 'ALL'});
    } else {
      this.setState({lang: value});
    }
  }

  renderUsersConnectionsBreakdown() {
    const id = 'usersConnectionsBreakdown';
    const {lang, loading, data} = this.state;
    let table = data && data[id][lang];

    if (!loading && table) {
      const sumCurrentSeason =
        table.currentSeason.activeDuringMonth +
        (table.currentSeason.inactiveDuringMonth || 0);
      const year = moment(table.currentSeasonStartDate).year();

      return (
        table && (
          <div id={id} className="mb-4">
            <div className="mt-3 table-responsive">
              <table className="table table-bordered no-margin table-striped">
                <thead>
                  <tr className="bg-gray">
                    <th>Type de user</th>
                    <th>Nombre</th>
                    <th className="text-center">%</th>
                    <th className="text-center">vs S-1</th>
                    <th className="text-center">vs M-1</th>
                    <th className="text-center">Commentaire</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={{width: '200px '}}>
                      dont SAU {year} - {parseInt(year, 10) + 1}
                    </td>
                    <th>
                      {numeral(table.currentSeason.activeDuringSeason).format(
                        '0,0',
                      )}
                    </th>
                    <td className="text-center">
                      {numeral(
                        (table.currentSeason.activeDuringSeason /
                          sumCurrentSeason) *
                          100,
                      ).format('0')}
                      &nbsp;%
                    </td>
                    <td className="text-center">
                      {numeral(table.previousSeason.activeDuringSeason).format(
                        '0,0',
                      )}
                    </td>
                    <td className="text-center">
                      {numeral(table.previousMonth.activeDuringSeason).format(
                        '0,0',
                      )}
                    </td>
                    <td className="text-center">
                      SAU : s'étant connecté à MPG au moins une fois depuis le
                      début de la saison en cours
                    </td>
                  </tr>
                  <tr>
                    <td style={{width: '200px '}}>dont montly</td>
                    <th>
                      {numeral(table.currentSeason.activeDuringMonth).format(
                        '0,0',
                      )}
                    </th>
                    <td className="text-center">
                      {numeral(
                        (table.currentSeason.activeDuringMonth /
                          sumCurrentSeason) *
                          100,
                      ).format('0')}
                      &nbsp;%
                    </td>
                    <td className="text-center">
                      {numeral(table.previousSeason.activeDuringMonth).format(
                        '0,0',
                      )}
                    </td>
                    <td className="text-center">
                      {numeral(table.previousMonth.activeDuringMonth).format(
                        '0,0',
                      )}
                    </td>
                    <td className="text-center">
                      S'étant connecté dans les 30 derniers jours
                    </td>
                  </tr>
                  <tr>
                    <td style={{width: '200px '}}>dont inactifs</td>
                    <th>
                      {numeral(table.currentSeason.inactiveDuringMonth).format(
                        '0,0',
                      )}
                    </th>
                    <td className="text-center">
                      {numeral(
                        (table.currentSeason.inactiveDuringMonth /
                          sumCurrentSeason) *
                          100,
                      ).format('0')}
                      &nbsp;%
                    </td>
                    <td className="text-center">
                      {numeral(table.previousSeason.inactiveDuringMonth).format(
                        '0,0',
                      )}
                    </td>
                    <td className="text-center">
                      {numeral(table.previousMonth.inactiveDuringMonth).format(
                        '0,0',
                      )}
                    </td>
                    <td className="text-center">
                      Ne s'étant pas connecté dans les 30 derniers jours
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        )
      );
    }
  }

  render() {
    const {lang, loading} = this.state;

    return (
      <div id="userConnections-stats-widget">
        <div className="box">
          <div className="box-header with-border">
            <h3 className="box-title pull-left">
              <i className="fa fa-sign-in" /> Nombre de users (date de
              connexion)
            </h3>
            <br />
            Nombre de users s'étant connecté sur la plateforme depuis le début
            de la saison
          </div>
          <div className="box-body">
            <div className="text-center">
              <div className="inline lang">
                <button
                  className={classNames('btn btn-box-tool', {
                    selected: lang === 'FR',
                  })}
                  onClick={() => this.toggleLang('FR')}>
                  <span className="flag-icon flag-icon-fr" />
                </button>
                <button
                  className={classNames('btn btn-box-tool', {
                    selected: lang === 'GB',
                  })}
                  onClick={() => this.toggleLang('GB')}>
                  <span className="flag-icon flag-icon-gb" />
                </button>
                <button
                  className={classNames('btn btn-box-tool', {
                    selected: lang === 'ES',
                  })}
                  onClick={() => this.toggleLang('ES')}>
                  <span className="flag-icon flag-icon-es" />
                </button>
                <button
                  className={classNames('btn btn-box-tool', {
                    selected: lang === 'OTHER',
                  })}
                  onClick={() => this.toggleLang('OTHER')}>
                  <img
                    src={earthFlag}
                    alt="Drapeau de la terre"
                    className="flag-img-btn"
                  />
                </button>
              </div>
              <button
                className="ml-2 inline btn btn-default"
                onClick={() => this.fetchStats()}>
                <i className="fa fa-refresh" />
              </button>
            </div>
          </div>
          {loading && <Loader />}
          {this.renderUsersConnectionsBreakdown()}
        </div>
      </div>
    );
  }
}

export default connect(dispatch => ({dispatch}))(MPMNumbersOfPlayersWidget);



// WEBPACK FOOTER //
// ./src/pages/Other/MPM/Stats/Widgets/NumbersOfPlayers/index.js